import type { ProjectData } from "./projects/types";
import { RETAIL_PROJECTS } from "./projects/retail";
import { OFFICE_PROJECTS } from "./projects/offices";
import { HOSPITALITY_PROJECTS } from "./projects/hospitality";

export type { ProjectData } from "./projects/types";

export const PROJECTS_LIST: ProjectData[] = [
  ...RETAIL_PROJECTS,
  ...OFFICE_PROJECTS,
  ...HOSPITALITY_PROJECTS,
];

export function getProjectBySlug(slug: string): ProjectData | undefined {
  return PROJECTS_LIST.find((p) => p.slug === slug || p.id === slug);
}
